module.exports = __webpack_public_path__ + "static/media/autumn_800x500.a8c856f5.jpg";